import resendApi from '@/api/post/resend-verify';
import Alert from '@/components/alert/alert-component';
import { PrimaryButton } from '@/components/button/button-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import Link from '@/components/link/link-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { useMutation } from '@/hooks/use-api';
import { BodyTextLarge, Heading1Text } from '@/utils/global-fonts';
import dayjs from 'dayjs';
import { FiChevronLeft } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

/**
 * Two Factor Authentication page.
 * @returns {JSX.Element} The rendered TwoFactorAuthentication page.
 */
const TwoFactorAuthentication = () => {
  const { state } = useLocation();

  const [resendVerification, { loading: verifyLoading }] =
    useMutation(resendApi);

  return (
    <PageWrapper>
      <Container>
        <BackIcon fontSize="20px" mr="12px" />
        <Link to="/login">Back</Link>
      </Container>
      <Heading1Text>You’ve got mail</Heading1Text>
      <FormWrapper defaultValues={{}} onSubmit={() => {}}>
        <BodyTextContainer>
          <BodyTextLarge>
            2 Factor Authentication is required. Please check your inbox to
            verify the login request.
          </BodyTextLarge>
        </BodyTextContainer>
        <ButtonContainer>
          <PrimaryButton
            buttonWidth="100%"
            buttonHeight="48px"
            type="submit"
            loading={verifyLoading}
            title="RESEND EMAIL"
            onClick={() => {
              if (
                localStorage.getItem('resendDate') === null ||
                dayjs(localStorage.getItem('resendDate')).isBefore(
                  dayjs().subtract(2, 'minutes'),
                )
              ) {
                resendVerification(state?.id).then(() => {
                  Alert({
                    icon: 'success',
                    text: 'Email sent successfully',
                  });
                  localStorage.setItem('resendDate', new Date());
                });
              } else {
                const time = dayjs().diff(
                  dayjs(localStorage.getItem('resendDate')),
                  'seconds',
                  true,
                );
                const timeLeft = 120 - time;
                const minutes = Math.floor(timeLeft / 60);
                const seconds = Math.floor(timeLeft % 60);
                Alert({
                  icon: 'error',
                  text: `Please wait ${minutes ? `${minutes} minute(s) and ` : ''}${seconds} second(s) before resending the email`,
                });
              }
            }}
          />
        </ButtonContainer>
      </FormWrapper>
    </PageWrapper>
  );
};

const Container = styled.div`
  display: flex;
  margin-top: 24px;
`;

const BackIcon = styled(FiChevronLeft)`
  margin-bottom: 24px;
  margin-right: ${({ mr }) => mr};
  font-size: ${({ fontSize }) => fontSize};
`;
const ButtonContainer = styled.div`
  margin-top: 40px;
`;
const BodyTextContainer = styled.div`
  margin-top: 24px;
`;

export default TwoFactorAuthentication;
